<template>
    <div class="container-fluid">
        <div class="row p-3">
            <div class="designRowOrga w-100">
                <div class="h3Organization">
                    <img src="../../../assets/images/title-icon.png" alt="">
                    <h3>Users</h3>
                </div>
                
                <!-- <router-link class="back-route" ref="backBtn" to="/results">
                    <font-awesome-icon :icon="['fas', 'angle-left']" size="lg"/>
                </router-link> -->
                <div class="right-header-container">
                    <div class="twoInputs">
                        <div class="btnInsideInput w-100">
                            <button @click="searchBackEndHandler" ref="buttonSearch">
                                <img src="../../../assets/images/SearchIcon.png" alt="">
                            </button>
                            <input type="text" id="free_search" class="form-control" v-model="search"
                                placeholder="Search" autocomplete="off"
                                @input="searchComeptition" maxlength="50">
                        </div>
                    </div>
                    <div class="fullInputs mb-4">
                        <div class="oneInput w-100">
                            <select id="filter_dates" class="form-select" v-model="sort" @change="getUsersScored">
                                <option value="false" selected disabled >Sort by Date</option>
                                <option value="asc">Oldest</option>
                                <option value="desc">Latest</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tabcontent tabcontent-border-style">
                <div class="table-container" v-if="users.length > 0">
                    <TableComponent class="main-table" :thead="thead" :tbody="users" :keys="keys" @sort="SortCompetition" @update="updateCompetition"
                                    model="userScoreIndividual" name="userScoreIndividual"
                                    updateUrl="/edit-scores" />

                    <div class="paginationLink">
                        <pagination :data="laravelData" @pagination-change-page="getUsersScored" :limit="3">
                            <template #prev-nav>
                                <span>Previous</span>
                            </template>
                            <template #next-nav>
                                <span>Next</span>
                            </template>
                        </pagination>
                    </div>
                </div>

                <div v-else class="text-center">No User Answer</div>

            </div>
        </div>
    </div>
</template>

<script>
    import TableComponent from "../../components/TableComponent";
    import LaravelVuePagination from 'laravel-vue-pagination';
    import score from "../../../api-services/score";
    import repository from "../../../api-services/repository";
    import getQuestionType from "../../../helpers/getQuestionName";

    export default {
        name:'pageShowUser-userscore',
        data(){
            return {
                // thead: ['Name' , 'Score' , 'Percentage' , 'true Or False' , 'Multiple Choice' , 'Free Text' , 'Slides' , 'Rank'],
                thead:['Name' , 'Score' , 'Percentage'],
                keys: ['name' , 'score', 'percentage'],
                permissions: [],
                users: [],
                filteredArray: [],
                originalUsers: [],
                laravelData: {},
                error: null,
                scorePerQuestion:[],
                search: '',
                sort: false,
                state: false,
                isSearch:false,
                isActive1:false,
                isActive2:false,
                status2:false,
            }
        },
        components: {
            TableComponent,
            'Pagination': LaravelVuePagination
        },
        mounted(){
            this.getUsersScored();
        },
        methods:{
            async getUsersScored(page=1){
                const competition_id = this.$route.params.id;
                try{
                    this.thead = ['Name' , 'Score' , 'Percentage'];
                    this.keys = ['name' , 'score', 'percentage'];
                    const response = await score.usersOfCompetition(competition_id , false , this.sort === false ? this.sort = 'desc' : this.sort , page);
                    this.thead.push(...response.data.data[0].titles);
                    this.keys.push(...response.data.data[0].keysData);
                    this.users = response.data.data;
                    this.laravelData = response.data;
                    this.originalUsers = response.data.data;

                }catch (e) {
                    // console.log(e);
                }
            },
            async SortCompetition(){
                let status = !this.status2;
                this.originalUsers.sort(function (a, b) {
                    return status ? -(a.id - b.id || a.name.localeCompare(b.name)) : -(b.id - a.id || b.name.localeCompare(a.name));
                });
                this.status2 = status;
            },
            async updateCompetition(e){
                let filteredData = this.users.filter(function (data) {
                    return data.id != e;
                });
                this.users = filteredData;
            },
            searchComeptition(e){
                let searchedValue = e.target.value;
                let searchedData = this.originalUsers.filter((data) => data.name.includes(searchedValue));
                this.users = searchedData;
            },
            async searchBackEndHandler(){
                await this.getUsersScored();
            }
        }
    }
</script>

<style scoped>
    p{
        margin-bottom: 0;
    }
    .no-data-header{
        font-size: 18px;
    }
    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #DDD !important;
        opacity: 0.5 !important; /* Firefox */
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #DDD !important;
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
        color: #DDD !important;
    }
    .create-btn-text{
        font-size: 17px;
    }
    .tabcontent{
        height:73vh;
        padding-top: 0 !important;
        overflow-y: auto;
    }
    .h3Organization{
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
    }
    .h3Organization img{
        margin-bottom:0;
        padding-right: 10px;
    }
    .h3Organization h3{
        text-transform: uppercase;
        font-weight: 600;
        margin-bottom: 0;
        font-size: calc(1.1rem+0.6vw);
    }
    .right-header-container{
           display: flex;
    flex-direction: row;
    justify-content: end;
    width: 45%;
    height: 35px;
    gap: 10px;
    }
    .right-header-container .btn-container{
        font-size: 16px;
        width: 25%;
        font-weight: normal;
    }
    .table-container:deep(p){
        margin-bottom: 0;
    }
    .twoInputs{
        width:45%;
    }
    .search-btn{
        width: 10%;
        border-radius: 6px 0 0 6px;
        background-color:#707070;
        align-items: center;
        padding-bottom: 3px;
    }
    .btnInsideInput{
        border-radius: 6px;
        background-color: #707070;
    }
    .btnInsideInput input{
        border-radius: 6px;
        background-color: #707070;
        padding-left: 0;
        padding-top: 5px;
        padding-bottom: 0;
        
    }
    .form-control {
        color: white !important;
        display: flex;
        justify-content: left;
        width:90% !important;
        padding-left: 10px !important;
    }
    .designRowOrga{
        padding-left:40px !important;
        padding-right: 40px;
        height: 50px;
        align-items: center;
        margin-bottom: 2%;
    }
    .paginationLink{
        font-size:11px;
        font-weight: bold;
        width:99%;
    }
    .fullInputs{
        width:25%;
        height: 100%;
    }
    .oneInput{
        height: 100%;
    }
    #filter_dates{
        width:100% !important;
        border: none;
        padding:0;
        padding-left: 10px;
        height: 100% !important;
    }
    #free_search::placeholder{
        opacity: 1 !important;
        color: white !important;
        /* font-size: 19px; */
    }
    @media(max-width:1280px){
        .h3Organization{
            width: 40% !important;
        }
        .h3Organization img{
            width: 5vh !important;
        }
        .right-header-container{
            width:60%;
            /* margin-top: 10px; */
        }
        .twoInputs{
            margin-bottom:0 !important;
        }
        .table-container :deep(thead :first-child){
        width:40% !important;
        }
        .tabcontent{
            padding-top: 0 !important;
            overflow-y: scroll;
        }
    }
    @media(max-height:767px){
        .tabcontent{
            height: 69vh;
        }
    }
</style>